import React, { useRef, useEffect, useCallback } from 'react';
import { GridList } from 'components/GridList';
import Text from 'components/styled/Text';
import TextInput from 'components/TextInput';
import PageHeader from 'components/styled/PageHeader';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { clientsSelector, userSelector } from 'store/selectors';
import { useReduxActions } from 'hooks/useReduxActions';
import { OrderFormatter } from 'components/OrdersFormatter';
import { PAGE_PATHS, ROLES } from '../../constants';
import { useNavigate } from 'react-router-dom';

const Clients = () => {
  const clients = useSelector(clientsSelector);
  const user = useSelector(userSelector);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const actions = useReduxActions();
  const ref = useRef(null);

  const columnDefs = [
    {
      headerName: t('clients.header.client.id'),
      field: 'index',
      pinned: 'left',
      minWidth: 75,
    },
    {
      headerName: t('clients.header.client'),
      valueGetter: ({ data }) => {
        if (data.profile) {
          return `${data.profile?.first_name} ${data.profile?.last_name}`;
        }
        return null;
      },
      field: 'client',
      minWidth: 150,
    },
    {
      headerName: t('clients.header.info'),
      field: 'info',
      minWidth: 150,
    },
    {
      headerName: t('clients.header.mobile'),
      valueGetter: ({ data }) =>
        data.profile ? `${data.profile?.phone}` : null,
      field: 'phone',
      minWidth: 150,
    },
    {
      headerName: t('clients.header.location'),
      field: 'location',
      minWidth: 150,
    },
    {
      headerName: t('clients.header.email'),
      field: 'email',
      minWidth: 200,
    },
    {
      headerName: t('clients.header.orders'),
      field: 'orders',
      type: 'tags',
      cellRenderer: ({ data }) => {
        const IDs = data.orders.map(item => item.ID);
        return <OrderFormatter data={IDs} />;
      },
    },
    {
      headerName: t('clients.header.date.added'),
      field: 'createdAt',
      type: 'date',
      minWidth: 150,
    },
  ];

  const onClientClicked = useCallback(
    e => {
      if (
        user.role === ROLES.FOUNDER &&
        e.colDef.field === 'orders' &&
        e.data.orders.length
      ) {
        navigate(
          `/${PAGE_PATHS.CREATE_JOB.ROOT}/${PAGE_PATHS.CREATE_JOB.INQUIRY}/${e.event.target.innerText}`,
        );
      } else if (user.role === ROLES.FOUNDER) {
        navigate(
          `${PAGE_PATHS.CLIENTS}/${user._id}/${PAGE_PATHS.CLIENT_PROFILE.PROFILE}`,
        );
      }
    },
    [user, clients], // eslint-disable-line
  );

  const handleTextInput = () => {};

  useEffect(() => {
    actions.getAllClients();
  }, []); // eslint-disable-line

  return (
    <>
      <PageHeader size="medium">
        <Text variant="title2">{t('clients.title')}</Text>
        <TextInput
          size="medium"
          onChange={handleTextInput}
          placeholder={t('clients.input.placeholder')}
        />
      </PageHeader>
      <GridList
        ref={ref}
        columnDefs={columnDefs}
        rowSelection="single"
        rows={clients}
        onCellClicked={onClientClicked}
      />
    </>
  );
};

export default Clients;
